import { CertificateType } from 'civil-status/view-models/document-birth-form';

export const getNameTypeEvent = (id?: string): string => {
  if (!id) {
    return '';
  }

  switch (id) {
    case CertificateType.cittadinanza:
      return 'CITTADINANZA';
    case CertificateType.matrimonio:
      return 'MATRIMONIO';
    case CertificateType.morte:
      return 'MORTE';
    case CertificateType.nascita:
      return 'NASCITA';
    case CertificateType.unioneCivile:
      return 'UNIONE CIVILE';
    default:
      return id;
  }
};
